import WMTSLayer from '@arcgis/core/layers/WMTSLayer';
import { GISServiceTypes } from '../gisServicesTypes';
import { LayerLoader, ensureLoadedLayerArray } from './LayerLoader';
import { resolveAdminOpacity } from './defaultLayerLoader';

export const wmtsLayerLoader: LayerLoader = {
  shouldUseLoader(service) {
    return service.service_type == GISServiceTypes.wmts;
  },

  async load(service) {
    const adminOpacity = resolveAdminOpacity(service);

    const layer = new WMTSLayer({
      url: service.gis_service_url,
      id: service.gisLayerID,
      activeLayer: {
        id: service?.attributes?.sublayers?.[0] || '',
      },
      visible: false,
      ...(adminOpacity !== undefined ? { opacity: adminOpacity } : {}),
    });

    await layer.load();

    return ensureLoadedLayerArray(layer);
  },
};
